// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blinking[data-v-5eba5fe2] {\n  -webkit-animation:blink-5eba5fe2 1s ease-in-out infinite alternate;\n  animation:blink-5eba5fe2 1s ease-in-out infinite alternate;\n}\n@-webkit-keyframes blink-5eba5fe2 {\n0% { opacity:0\n}\n100% { opacity:1\n}\n}\n@keyframes blink-5eba5fe2 {\n0% { opacity:0\n}\n100% { opacity:1\n}\n}\n", ""]);
// Exports
module.exports = exports;
